module.exports = __webpack_public_path__ + "img/ring_r_c_null_0@2x.05cd0756.png";